import { gql } from 'apollo-angular';

import { ASSET_FRAGMENT } from '../../../common/graphql/fragments.graphql';

export const GET_COMPARE_PRODUCT = gql`
    query GetCompareProduct($id: ID!) {
        product(id: $id) {
            id
            name
            slug
            description
            featuredAsset {
                ...Asset
            }
            facetValues {
                id
                name
                facet {
                    id
                    code
                    name
                }
            }
            variants {
                id
                priceWithTax
            }
            customFields {
                specifications
            }
        }
    }
    ${ASSET_FRAGMENT}
`;
